// Central content-type → lucide icon helper. Externalized from the
// local helper inside `taxonomy-document-navigator.tsx` so grid cells,
// file-viewer drawer, and any other surface that renders a file row by
// content type can share one mapping.

import {
  File,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileType,
  type LucideIcon,
} from "lucide-react";

/**
 * Return the lucide icon component for a file's MIME content type.
 * Falls back to a generic `File` icon for unknown/missing types.
 */
export function getFileTypeIcon(contentType: string | null | undefined): LucideIcon {
  if (!contentType) return File;
  const ct = contentType.toLowerCase();

  if (ct.includes("pdf")) return FileText;
  if (
    ct.includes("spreadsheet") ||
    ct.includes("excel") ||
    ct === "text/csv" ||
    ct === "application/csv"
  ) {
    return FileSpreadsheet;
  }
  if (ct.includes("wordprocessingml") || ct.includes("msword") || ct.endsWith("/docx")) {
    return FileType;
  }
  if (ct.startsWith("image/")) return FileImage;
  if (ct.startsWith("text/") || ct === "application/json" || ct === "application/xml") {
    // Code-ish for json/xml, plain text otherwise.
    if (ct === "application/json" || ct === "application/xml") return FileCode;
    return FileText;
  }
  return File;
}
